const OFFLINE_ERROR = 'not_available_offline'

module.exports = {
  OFFLINE_ERROR: OFFLINE_ERROR
}
